var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('os-sheet',{staticClass:"minimal-critical-height"},[_c('os-sheet-content',[_c('os-change-password-form')],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }